import { isEqual } from 'lodash';
import React from 'react';
import { updateUserProfileAction } from '../../../app/redux/actions/userProfileCompletionActions';
import { useAppDispatch } from '../../../app/redux/hooks';
import CompletionScreen from './CompletionScreen';
import { ProfileCompletionProgressBar } from './ProfileCompletionProgressBar';
import ProfileCompletionForm from './forms/ProfileCompletionForm';
import useQuestionary from './hooks/useQuestionary';

const ProfileQuestionaryWidget = () => {
  const dispatch = useAppDispatch();
  const {
    currentQuestionIndex,
    currentQuestion,
    showCompletionScreen,
    moveToNextQuestion,
    completionPercentage,
    moveToPreviousQuestion,
    user,
    unansweredQuestions
  } = useQuestionary();
  const group = currentQuestion?.group ?? '';
  //Pass this down to pagination, at this level the initial count won't change even when user updates.
  const initialQuestionsCount = unansweredQuestions ? unansweredQuestions.length : 0;
  const handleUpdateUserProfile = (data: any) => {
    const currentData = data.profile[group];
    let doUpdate = false;
    for (const key in currentData) {
      if (group && key && user?.fieldGroups?.[group]?.[key]) {
        let savedValues = user.fieldGroups[group][key].value;
        //Only run patch user request if the value has changed.
        if (Array.isArray(savedValues)) {
          savedValues = user.fieldGroups[group][key].value.map((savedValue: any) => {
            return savedValue.value;
          });
          if (!isEqual(Object.values(data.profile[group][key]), savedValues)) {
            doUpdate = true;
          }
        } else {
          if (!isEqual(data.profile[group][key], user.fieldGroups[group][key].value)) {
            doUpdate = true;
          }
        }
      } else {
        //User does not have this group or field saved, save value
        doUpdate = true;
      }
    }
    if (doUpdate) dispatch(updateUserProfileAction(data));
    moveToNextQuestion();
  };

  return !showCompletionScreen ? (
    <>
      <div className="dialog-content-header mb-2">
        <ProfileCompletionProgressBar
          overallBkgColour="bg-tertiary-200"
          completeBkgColour="bg-tertiary"
          percentage={completionPercentage}
        />
      </div>
      {currentQuestion && (
        <>
          <ProfileCompletionForm
            key={currentQuestion?.field}
            questionData={currentQuestion!}
            currentItemIndex={currentQuestionIndex}
            initialQuestionsCount={initialQuestionsCount}
            nextItem={moveToNextQuestion}
            previousItem={moveToPreviousQuestion}
            onSubmit={handleUpdateUserProfile}
          />
        </>
      )}
    </>
  ) : (
    <>
      <div className="dialog-content-header mb-2">
        <ProfileCompletionProgressBar
          overallBkgColour="bg-tertiary-200"
          completeBkgColour="bg-tertiary"
          percentage={completionPercentage}
        />
      </div>
      <CompletionScreen />
    </>
  );
};

export default ProfileQuestionaryWidget;
